import teamLogoPlaceholder from "../images/ic_logo.svg";

export { teamLogoPlaceholder };

/**
 * A team with no logo of its own answers with null, and an <img> with no src renders as
 * a broken tile. Fall back to the same mark the global search dropdown uses, and catch a
 * stored path that no longer resolves on the media host.
 */
export const swapInTeamLogoPlaceholder = (event) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = teamLogoPlaceholder;
};
